import { icon } from "../lib/icons";

export function progressHTML(): string {
  return `
<div x-data="progress()" class="progress-shell">
  <div class="student-list">
    <h2 x-text="$store.board.role === 'Student' ? 'My progress' : 'Students'"></h2>
    <template x-for="s in studentList" :key="s.id">
      <button class="student-row"
        :class="$store.board.selectedStudentId === s.id ? 'active' : ''"
        @click="$store.board.selectedStudentId = s.id">
        <span class="avatar" :style="\`background: \${s.color}22; color: \${s.color}\`" x-text="s.initials"></span>
        <div style="flex: 1">
          <div class="student-name" x-text="s.name"></div>
          <div class="student-meta">
            <span x-text="\`\${progressFor(s.id).program} · \${progressFor(s.id).completed}/\${progressFor(s.id).total}\`"></span>
            <template x-if="progressFor(s.id).blockers.length > 0">
              <span style="color: var(--bad-600); margin-left: 6px; font-weight: 600">· blocker</span>
            </template>
          </div>
          <div class="progress-mini"><div :style="\`width: \${pct(s.id)}%\`"></div></div>
        </div>
      </button>
    </template>
  </div>

  <div class="progress-detail">
    <div class="detail-hero">
      <span class="avatar xl" :style="\`background: \${selectedUser.color}22; color: \${selectedUser.color}\`" x-text="selectedUser.initials"></span>
      <div>
        <div class="program" x-text="selectedProgress.program"></div>
        <h2 x-text="selectedUser.name"></h2>
        <div class="muted" style="font-size: 13px; margin-top: 4px">
          Next up: <strong style="color: var(--ink-900)" x-text="selectedProgress.upcoming"></strong>
          <span class="dim mono" style="margin-left: 8px" x-text="selectedProgress.upcomingDate"></span>
        </div>
        <div class="progress-bar"><div :style="\`width: \${selectedPct}%\`"></div></div>
        <div style="display: flex; justify-content: space-between; font-size: 11px; color: var(--ink-500); margin-top: 4px">
          <span class="mono" x-text="\`\${selectedProgress.completed} of \${selectedProgress.total} lessons\`"></span>
          <span class="mono" x-text="\`\${selectedPct}%\`"></span>
        </div>
      </div>
      <div class="hero-stats">
        <div class="stat">
          <div class="lbl">Dual</div>
          <div class="val" x-text="selectedProgress.flightHours.dual.toFixed(1)"></div>
        </div>
        <div class="stat">
          <div class="lbl">Solo</div>
          <div class="val" x-text="selectedProgress.flightHours.solo.toFixed(1)"></div>
        </div>
        <div class="stat">
          <div class="lbl">Total</div>
          <div class="val" x-text="selectedProgress.flightHours.total.toFixed(1)"></div>
        </div>
      </div>
    </div>

    <div class="card padded">
      <h3 style="margin: 0 0 10px; font-size: 13px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--ink-700)">
        Blockers & next action
      </h3>
      <template x-if="selectedProgress.blockers.length === 0">
        <div class="no-blockers">
          ${icon("check", 14)} No active blockers. Student is clear to progress.
        </div>
      </template>
      <template x-if="selectedProgress.blockers.length > 0">
        <div style="display: grid; gap: 8px">
          <template x-for="bl in selectedProgress.blockers" :key="bl.text">
            <div class="blocker-row" :class="bl.severity === 'high' ? '' : 'warn'">
              <span class="blocker-icon">${icon("warn", 16)}</span>
              <div style="flex: 1">
                <strong x-text="bl.text"></strong>
                <p x-text="\`Linked to upcoming booking warning · \${bl.kind}.\`"></p>
              </div>
              <template x-if="$store.board.role === 'Owner' || $store.board.role === 'Scheduler' || $store.board.role === 'Flight Instructor'">
                <button type="button" class="btn btn-sm">Resolve</button>
              </template>
              <template x-if="$store.board.role === 'Student'">
                <button type="button" class="btn btn-sm">Contact CFI</button>
              </template>
            </div>
          </template>
        </div>
      </template>
      <div style="margin-top: 12px; padding: 12px; background: var(--brand-50); border: 1px solid var(--brand-100); border-radius: var(--radius-sm); display: flex; gap: 10px; align-items: flex-start">
        <span style="color: var(--brand-600); flex-shrink: 0; padding-top: 1px">${icon("arrowR", 16, 1.8, "currentColor")}</span>
        <div>
          <div style="font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: var(--brand-700)">
            Suggested next lesson
          </div>
          <div style="font-size: 13.5px; margin-top: 2px; color: var(--ink-800)" x-text="selectedProgress.recommendation"></div>
        </div>
      </div>
    </div>

    <div class="detail-grid">
      <div class="card padded">
        <h3 style="margin: 0 0 6px; font-size: 13px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--ink-700)">
          PPL syllabus · 24 lessons
        </h3>
        <div class="muted" style="font-size: 12px">Each cell is one lesson. Hover for name.</div>
        <div class="lesson-track">
          <template x-for="pl in $store.board.lookups.programLessons" :key="pl.programId + ':' + pl.position">
            <div class="lesson-cell"
              :class="(pl.position - 1) < selectedProgress.completed ? 'done' : (pl.position - 1) === selectedProgress.completed ? 'next' : ''"
              :title="pl.position + '. ' + pl.name"
              x-text="pl.position"></div>
          </template>
        </div>
        <div style="display: flex; gap: 14px; font-size: 11px; margin-top: 10px; color: var(--ink-500)">
          <span><span style="display: inline-block; width: 10px; height: 10px; background: var(--brand-500); border-radius: 2px; margin-right: 4px; vertical-align: middle"></span> Completed</span>
          <span><span style="display: inline-block; width: 10px; height: 10px; background: var(--brand-50); border: 1.5px dashed var(--brand-500); border-radius: 2px; margin-right: 4px; vertical-align: middle"></span> Up next</span>
          <span><span style="display: inline-block; width: 10px; height: 10px; background: var(--ink-100); border-radius: 2px; margin-right: 4px; vertical-align: middle"></span> Pending</span>
        </div>
      </div>

      <div class="card padded">
        <h3 style="margin: 0 0 8px; font-size: 13px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--ink-700)">
          Recent gradings
        </h3>
        <template x-for="g in selectedProgress.recentGrades" :key="g.lesson + g.date">
          <div class="recent-grade">
            ${icon("doc", 14)}
            <span class="lesson" x-text="g.lesson"></span>
            <span class="chip" :class="g.grade === 'Excellent' ? 'ready' : g.grade === 'Needs review' ? 'warning' : 'muted'">
              <span class="chip-dot"></span><span x-text="g.grade"></span>
            </span>
            <span class="date mono" x-text="g.date"></span>
          </div>
        </template>
      </div>
    </div>

    <template x-if="$store.board.role !== 'Student'">
      ${schoolThroughputHTML()}
    </template>
  </div>
</div>
`;
}

function schoolThroughputHTML(): string {
  return `
    <div class="card padded">
      <h3 style="margin: 0 0 10px; font-size: 13px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--ink-700)">
        School throughput · this month
      </h3>
      <div class="owner-summary">
        <div class="metric">
          <div class="lbl">Students active</div>
          <div class="val">3</div>
          <div class="sub">PPL track</div>
        </div>
        <div class="metric">
          <div class="lbl">Lessons logged</div>
          <div class="val">25</div>
          <div class="sub up">+4 vs last month</div>
        </div>
        <div class="metric">
          <div class="lbl">Avg pace</div>
          <div class="val">3.2<span style="font-size: 13px; color: var(--ink-500)">/wk</span></div>
          <div class="sub">lessons per student</div>
        </div>
        <div class="metric">
          <div class="lbl">Stalled</div>
          <div class="val" style="color: var(--bad-600)">1</div>
          <div class="sub down">R. Sharma, medical</div>
        </div>
      </div>
    </div>
  `;
}
